var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"margin-tb-25 my-product"},[_c('product-search-bar',{on:{"doSearch":_vm.doSearch}}),_c('product-data-list',{ref:"productList"}),(false)?_c('category-dialog'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }